import { getLogger } from '@blueberry/observability'
import { initializeSentry } from '@blueberry/observability/sentry'

const logger = getLogger('signup/instrumentation')

initializeSentry({
  dsn: 'https://54ed0c6f87da55504b7a68b6169b5d0c@o213845.ingest.us.sentry.io/4508169292021760',
})

// initializeReplayTracker({
//   keys: {
//     staging: 'ctYEulNSlTSQats359C5',
//     production: 'iPuQSSWbYTAlpRXjRhag',
//   },
// })
//   .then(() => {
//     logger.info('Replay tracker initialized')
//   })
//   .catch((error) => {
//     logger.error('Failed to initialize replay tracker', error)
//   })
